export const Wait = 30000;
